import { navigateToLegacy } from 'utils/UrlOpen';
import PropTypes from 'prop-types';

export default function NotFound({ location }) {
  if (location.pathname) {
    navigateToLegacy(location.pathname);
  }

  return null;
}

NotFound.propTypes = {
  location: {
    pathname: PropTypes.string,
  },
};
